import React from "react";
import AdSenseBanner from "../components/AdSenseBanner";

function Downloads() {
  return (
    <div
      className="container"
      style={{ paddingTop: "80px", paddingBottom: "40px" }}
    >
      <h2 className="mb-4">Downloads e Recursos</h2>
      <AdSenseBanner />

      <ul>
        <li>
          <a
            target="_blank"
            href="https://1drv.ms/u/s!AofFYGmkqJOelZs21-cX8QlXz1yBxA"
            rel="noreferrer"
            download
            className="btn btn-primary"
          >
            Baixar MMCodingWriter v2.3
          </a>
        </li>
      </ul>

      <p>
        <strong>Observação:</strong> Sempre verifique a compatibilidade da
        versão do software com seu veículo.
      </p>
    </div>
  );
}

export default Downloads;
